import { useEffect, useState } from "react"
// import classNames from "classnames"

import { useParams, useRouteMatch } from "react-router-dom"

import { MDB_TYPES } from "@meddbriefer/scenario-data/constants"
import { useScenarioType } from "../ScenarioTypeContext"

import InterventionsEditorLayout from "./InterventionEditorLayout"

import InlineEditor from "../InlineEditor"
import AddEntity from "../AddEntity"

import { genDistinguishingPromptRec } from "./types"

import { getDistPromptsBC } from "../urls"

const DistPromptsList = () => {
    const params = useParams()
    const { url } = useRouteMatch()
    const {
        scenarioType,
        intvPrompts,
        intvPromptAnswers,
        uniqueIDs,
        uniqueLabels,
    } = useScenarioType()
    const [distPrompts, setDistPrompts] = useState(null)

    const addDistPrompt = (entityType, newID, newLabel) => {
        intvPrompts.add(genDistinguishingPromptRec(newID, newLabel))
    }

    const deleteHandler = (item) => {
        const myAnswers = scenarioType.interventionPromptAnswers.filter(e => e.promptID === item.id)
        let msg = `Are you sure you wish to delete the prompt ${item.label} and all of of it's children?\n`
        if (myAnswers.length > 0) {
            msg += `\nAnswers:\n`
            msg += myAnswers.map(e => e.label).join('\n')
        }
        if (window.confirm(msg)) {
            myAnswers.forEach(e => intvPromptAnswers.remove(e.id))
            intvPrompts.remove(item.id)
        } else {
            alert("deletion aborted")
        }
    }

    useEffect(
        () => {
            setDistPrompts(scenarioType.interventionPrompts.filter(e => e.type === MDB_TYPES.DIST_PROMPT))
        }, [scenarioType.interventionPrompts]
    )

    if (!distPrompts) { return (<div>loading...</div>)}

    return (
        <InterventionsEditorLayout
            breadcrumbs = {
                [getDistPromptsBC(params)]
            }
        >
            <InlineEditor
                heading="Distiguishing Prompts"
                records={distPrompts}
                fields={[
                    {name: "id", label: "ID", colWidthPct: 48, widget: null},
                    {name: "label", label: "Label", colWidthPct: 52, widget: null}
                ]}
                allowChangeOrder={false}
                editLink={true}
                editBaseURL={url}
                onDelete={deleteHandler}
            >
                <AddEntity
                    entitiesDesc={[{type: "distinguishingPrompt", name: "Distinguishing Prompt", labelsUnique: true}]}
                    addHandler={addDistPrompt}
                    uniqueIDs={uniqueIDs}
                    uniqueLabels={uniqueLabels}
                />
            </InlineEditor>
        </InterventionsEditorLayout>
    )

}

export default DistPromptsList